import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import './SiteFooter.css';

export default function SiteFooter() {
  const { language } = useLanguage();
  const text = language === 'zh' ? {
    rights: '保留所有权利',
    links: [
      ['使用条款', '/terms'],
      ['隐私政策', '/privacy-policy'],
      ['Cookie 政策', '/cookie-policy'],
      ['帮助中心', '/help'],
      ['关于我们', '/about'],
    ],
  } : {
    rights: 'All rights reserved',
    links: [
      ['Terms of Use', '/terms'],
      ['Privacy Policy', '/privacy-policy'],
      ['Cookie Policy', '/cookie-policy'],
      ['Help Center', '/help'],
      ['About', '/about'],
    ],
  };

  return (
    <footer className="site-footer">
      <div className="container site-footer-inner">
        <div>
          <Link to="/" className="site-footer-brand">Oblitrok</Link>
          <p>© 2026 Oblitrok. {text.rights}.</p>
        </div>
        <nav aria-label={language === 'zh' ? '页脚链接' : 'Footer links'}>
          {text.links.map(([label, href]) => <Link key={href} to={href}>{label}</Link>)}
        </nav>
      </div>
    </footer>
  );
}
